var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"assembly"},[(_vm.$store.getters.isLayout)?_c('Header'):_vm._e(),_c('div',{class:[
      _vm.$store.getters.isLayout ? 'assembly-content' : 'assembly-content-height',
    ]},[(_vm.$store.getters.isLayout)?_c('Bread'):_vm._e(),_c('keep-alive',[_c('router-view')],1)],1),(_vm.$store.getters.isLayout)?_c('Footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.path != '/resourceLibrary/index'),expression:"$route.path != '/resourceLibrary/index'"}]}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }